// extracted by mini-css-extract-plugin
export default {"groupContainer":"RiskGroupPage_groupContainer__3JH3s","riskGroupTitle":"RiskGroupPage_riskGroupTitle__Us6ts","riskGroupInfoText":"RiskGroupPage_riskGroupInfoText__XYHBR"};